import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEpisodes } from '@contexts/EpisodesContext';
import { ROUTES } from '@constants/routes';
import { getNavigationState } from '@models/navigation/navigationModel';

export function useNavigationController() {
  const navigate = useNavigate();
  const location = useLocation();
  const { feedMetadata } = useEpisodes();
  const navigationState = getNavigationState(location.pathname);

  const goHome = useCallback(() => navigate(ROUTES.HOME), [navigate]);
  const goToAllEpisodes = useCallback(
    () => navigate(ROUTES.ALL_EPISODES),
    [navigate]
  );

  return {
    feedMetadata,
    ...navigationState,
    goHome,
    goToAllEpisodes
  };
}
